"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.breakpointsConstants = void 0;

/* eslint-disable @libjs-utils/eslint/prefer-singular-enums, @typescript-eslint/naming-convention */
var breakpointsConstants;
exports.breakpointsConstants = breakpointsConstants;

(function (breakpointsConstants) {
  breakpointsConstants["xxxs"] = "xxxsmall";
  breakpointsConstants["xxs"] = "xxsmall";
  breakpointsConstants["xs"] = "xsmall";
  breakpointsConstants["s"] = "small";
  breakpointsConstants["m"] = "medium";
  breakpointsConstants["l"] = "large";
  breakpointsConstants["xl"] = "xlarge";
  breakpointsConstants["xxl"] = "xxlarge";
  breakpointsConstants["xxxl"] = "xxxlarge";
})(breakpointsConstants || (exports.breakpointsConstants = breakpointsConstants = {}));

var breakpoints;

(function (breakpoints) {
  breakpoints[breakpoints["xxxsmall"] = 320] = "xxxsmall";
  breakpoints[breakpoints["xxsmall"] = 375] = "xxsmall";
  breakpoints[breakpoints["xsmall"] = 600] = "xsmall";
  breakpoints[breakpoints["small"] = 960] = "small";
  breakpoints[breakpoints["medium"] = 1024] = "medium";
  breakpoints[breakpoints["large"] = 1280] = "large";
  breakpoints[breakpoints["xlarge"] = 1440] = "xlarge";
  breakpoints[breakpoints["xxlarge"] = 1600] = "xxlarge";
  breakpoints[breakpoints["xxxlarge"] = 1920] = "xxxlarge";
})(breakpoints || (breakpoints = {}));

var _default = breakpoints;
exports["default"] = _default;